import { render, staticRenderFns } from "./CellRenderDeleteIcon.vue?vue&type=template&id=ef8b8218"
import script from "./CellRenderDeleteIcon.vue?vue&type=script&lang=js"
export * from "./CellRenderDeleteIcon.vue?vue&type=script&lang=js"
import style0 from "./CellRenderDeleteIcon.vue?vue&type=style&index=0&id=ef8b8218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports